import {useApiStore} from '../../stores/apiStore';
import {translate} from '../mixins/translation';
import {useToast} from '../components/toast/useToast';

export function handleWebappUpgradeRequired(response: Response) {
    const forceReload = response.headers.get('x-force-reload') === 'true';

    if (!forceReload) {
        return;
    }

    const apiStore = useApiStore();

    if (apiStore.isToastMuted()) {
        return;
    }

    const updateRequiredMessageKey = 'app.notification.webapp_version.text';
    const upgradeRequiredMessage = translate(updateRequiredMessageKey);
    const updateRequiredLinkLabelKey = 'app.notification.webapp_version.link_text';
    const upgradeRequiredLinkLabel = translate(updateRequiredLinkLabelKey);

    if (
        updateRequiredMessageKey === upgradeRequiredMessage ||
        updateRequiredLinkLabelKey === upgradeRequiredLinkLabel
    ) {
        return;
    }

    apiStore.setTimestamp();

    useToast().info(upgradeRequiredMessage, {
        customData: {
            link: {
                label: upgradeRequiredLinkLabel,
                callbackFn: () => window.location.reload(),
            },
        },
        life: 0,
    });
}
